import type CurrentAuthService from '../commons/services/current-auth.service';
import type {Auth, RecordCollection} from 'typings/portaro.be.types';

export class RecordCollectionsService {
    public static serviceName = 'recordCollectionsService';

    /*@ngInject*/
    constructor(private currentAuthService: CurrentAuthService, private currentAuth: Auth) {
    }

    public isOwner(recordCollection: RecordCollection): boolean {
        return recordCollection.owner.id === this.currentAuth.activeUser.id;
    }

    public canCreateRootCollection(): boolean {
        return this.isAdminOrLibrarian();
    }

    public canShowCreatorAndDepartment(): boolean {
        return this.isAdminOrLibrarian();
    }

    public canShowContextMenuButton(): boolean {
        return this.isAdminOrLibrarian();
    }

    private isAdminOrLibrarian(): boolean {
        return this.currentAuthService.hasAnyRole('ROLE_ADMIN', 'ROLE_LIBRARIAN');
    }
}